// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__lHpJy","header":"PatientBlock_header__14fOM","label":"PatientBlock_label__3SQQB","option":"PatientBlock_option__2f104"};